<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="edit-dialog ah-detail-dialog"
        top="5vh"
        append-to-body
        @close="onClose"
        @open="onOpen"
    >
        <template slot="title">
            <div class="title">
                <span v-if="isAdd">新增財務{{ purposeZh }}</span>
                <span v-else>編輯財務{{ purposeZh }}</span>
            </div>
        </template>
        <div class="ah-page variable-edit-dialog">
            <div class="ah-container">
                <el-form ref="form" :model="form" :rules="rules" :label-position="isMobile() ? 'top' : 'right'" label-width="180px" v-loading="isLoading">
                    <el-form-item prop="type" label="類型">
                        <el-radio-group v-model="form.type" size="large" :disabled="!isAdd" @change="onTypeChange" class="radio-option-cards large">
                            <el-radio v-if="urlType == 'income'" :label="1" border>
                                <div class="icon">
                                    <i class="el-icon-receiving"></i>
                                </div>
                                <div class="title">營業其他收入</div>
                                <div class="intro">非營業交易產生的收入<br />（例如：存款利息、政府利息補貼...）</div>
                            </el-radio>
                            <el-radio v-if="urlType == 'income'" :label="5" border>
                                <div class="icon">
                                    <i class="el-icon-office-building"></i>
                                </div>
                                <div class="title">財務資產收入</div>
                                <div class="intro">
                                    （例如：保證金收回、退稅、投資收回、預收款...）
                                </div>
                            </el-radio>
                            <el-radio v-if="urlType == 'payout'" :label="2" border>
                                <div class="icon">
                                    <i class="el-icon-receiving"></i>
                                </div>
                                <div class="title">營業其他支出</div>
                                <div class="intro">非營業交易產生的支出<br />（例如：借款利息支出、違約罰款、銀行手續費、印花規費、物品損失...）</div>
                            </el-radio>
                            <el-radio v-if="urlType == 'payout'" :label="6" border>
                                <div class="icon">
                                    <i class="el-icon-office-building"></i>
                                </div>
                                <div class="title">財務資產支出</div>
                                <div class="intro">
                                    （例如：對外投資、應繳營業稅、應繳營所稅、台外幣互換、暫付款、盈餘分配...）
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="iteM_SNO">
                        <template v-slot:label>
                            {{ form.flg == -1 ? "支出項目" : "收入項目" }}
                        </template>
                        <div class="block">
                            <ahSelectVariableStateItem
                                v-model="form.iteM_SNO"
                                :enableType="[statementType]"
                                :show-system-default="form.type === 1"
                                :disabled="isRemittance(form.iteM_SNO)"
                                @onLoaded="onVaribleStateSelectorLoaded"
                                @change="onVariableStateItemChange"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                        <ahSuggestAccountingItemsSelector
                            ref="ahSuggestAccountingItemsSelector"
                            v-model="form.accno"
                            @loaded="onAhSuggestAccountingItemsSelectorLoaded"
                        ></ahSuggestAccountingItemsSelector>
                    </el-form-item>
                    <el-form-item prop="tpc" label="摘要">
                        <el-input
                            v-model="form.tpc"
                            type="textarea"
                            :maxlength="100"
                            :show-word-limit="true"
                            class="ah-el-input-textarea"
                            autosize
                            resize="none"
                            @keydown.enter.native="onTpcInputKeydown($event)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="bnK_SNO" :label="form.flg == -1 ? '付款銀行帳戶' : '收款銀行帳戶'">
                        <ah-el-select-bank-account v-model="form.bnK_SNO" document-type="variable-statement" @change="onBankChange"></ah-el-select-bank-account>
                    </el-form-item>
                    <el-form-item prop="paY_DAT" :label="form.flg == -1 ? '付款日期' : '收款日期'">
                        <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="amt" label="金額">
                        <money-input v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" style="width: 200px; margin-right: 5px" />
                        <el-select v-model="form.cny" prop="cny" style="width: 100px" :disabled="true" no-data-text="無資料">
                            <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.cny !== 'TWD'" prop="rat" label="匯率">
                        <money-input v-model="form.rat" :precision="form.cny == 'TWD' ? 0 : 4" style="width: 200px" />
                    </el-form-item>
                    <el-form-item prop="mem" label="備註" :rules="isAdd ? [{ required: false }] : rules_alt.mem">
                        <el-input type="textarea" v-model="form.mem" :autosize="{ minRows: 5, maxRows: 15 }" :maxlength="200" :show-word-limit="true"></el-input>
                    </el-form-item>
                    <div class="transfer-section">
                        <div class="section-title">{{ form.flg == -1 ? "收款對象" : "帳款來源" }}</div>
                        <el-form-item prop="vdR_BNK_BOO" :label="form.flg == -1 ? '收款銀行' : '付款銀行'" :rules="isOneOfTargetInput ? rules_target.vdR_BNK_BOO : [{ required: false }]">
                            <ah-el-select-bank v-model="form.vdR_BNK_BOO" :branch="form.vdR_BNK_DOO" @branchInput="form.vdR_BNK_DOO = $event" clearable></ah-el-select-bank>
                        </el-form-item>
                        <el-form-item prop="vdR_BNK_ACC" :label="form.flg == -1 ? '收款帳戶' : '付款帳戶'" :rules="isOneOfTargetInput ? rules_target.vdR_BNK_ACC : [{ required: false }]">
                            <ah-el-input-bank-acc v-model="form.vdR_BNK_ACC" :bankBoo="form.vdR_BNK_BOO"></ah-el-input-bank-acc>
                        </el-form-item>
                        <el-form-item prop="vdR_BNK_TPC" :label="form.flg == -1 ? '收款戶名' : '付款戶名'" :rules="isOneOfTargetInput ? rules_target.vdR_BNK_TPC : [{ required: false }]">
                            <el-input v-model="form.vdR_BNK_TPC" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop=""><el-alert type="info" :closable="false" show-icon style="margin-bottom: 15px; padding-bottom: 12px; line-height: 100%;">填寫以上銀行資訊後，此筆交易才會出現在「銀行匯款明細、匯費」中。</el-alert></el-form-item>
                    </div>

                    <div class="files-view-section">
                        <FilesView ref="FilesView" :form="form" create-mode @change="onChangeFiles" @reload="fetchExistsData" />
                    </div>
                </el-form>
                <div style="padding-bottom: 20px"></div>
                <center>
                    <el-button type="primary" class="primary-action" :loading="isSubmitting" @click="onSubmit">
                        送出
                    </el-button>
                </center>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { statementTypes } from '@/assets/commonData/options';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import FilesView from '@/components/dashboard/Finance/VariableStatement/FilesView.vue';

export default {
    components: {
        ahElSelectBankAccount,
        ahSelectVariableStateItem,
        ahElSelectBank,
        ahElInputBankAcc,
        ahSuggestAccountingItemsSelector,
        FilesView,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: Number,
            default: null,
        },
        purpose: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isAhSuggestAccountingItemsSelectorShow: false,

            isLoading: false,
            isSubmitting: false,
            statementType: '',
            suggestAccountItems: [],
            form: {
                type: 0, // 1:營業其他收入, 2:營業其他支出, 5: 財務資產收入, 6:財務資產支出
                sno: null,
                flg: null,
                bnK_SNO: null,
                paY_DAT: Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                ),
                iteM_SNO: null,
                accno: null,
                cny: 'TWD',
                amt: null,
                rat: 1,
                tpc: null,
                mem: null,
                vdR_BNK_BOO: null,
                vdR_BNK_DOO: null,
                vdR_BNK_ACC: null,
                vdR_BNK_TPC: null,

                attachments: [],
            },
            rules: {
                tpc: [
                    {
                        required: true,
                        message: '請填寫摘要',
                        trigger: 'blur',
                    },
                ],
                bnK_SNO: [
                    {
                        required: true,
                        message: '請選擇銀行帳戶',
                        trigger: 'change',
                    },
                ],
                paY_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'change',
                    },
                ],
                iteM_SNO: [
                    {
                        required: true,
                        message: '請選擇項目',
                        trigger: 'change',
                    },
                ],
                amt: [
                    {
                        required: true,
                        message: '請輸入金額',
                        trigger: 'blur',
                    },
                ],
            },
            rules_alt: {
                mem: [
                    {
                        required: true,
                        message: '修改請填寫修改原因於備註',
                        trigger: 'blur',
                    },
                ],
            },
            rules_target: {
                vdR_BNK_BOO: [
                    {
                        required: true,
                        message: '請填寫完整匯款對象資訊',
                        trigger: 'blur',
                    },
                ],
                vdR_BNK_ACC: [
                    {
                        required: true,
                        message: '請填寫完整匯款對象資訊',
                        trigger: 'blur',
                    },
                ],
                vdR_BNK_TPC: [
                    {
                        required: true,
                        message: '請填寫完整匯款對象資訊',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isAdd() {
            return this.sno === null;
        },
        isOneOfTargetInput() {
            return !!this.form.vdR_BNK_BOO || !!this.form.vdR_BNK_DOO || !!this.form.vdR_BNK_ACC || !!this.form.vdR_BNK_TPC;
        },
        currencyList() {
            return this.$store.getters['cny/cnyOptions'];
        },
        urlType() {
            if (this.purpose) {
                return this.purpose;
            }
            if (this.form.type) {
                if (this.form.type === 1 || this.form.type === 5) {
                    console.log('R');
                    return 'income';
                }
                if (this.form.type === 2 || this.form.type === 6) {
                    console.log('S');
                    return 'payout';
                }
            }
            return 'payout';
        },
        purposeZh() {
            if (this.form.flg > 0) return '收入';
            return '支出';
        },
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
    },
    methods: {
        async fetchExistsData(sno) {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: `/Tool/GetStatementForm?SNO=${sno}`,
                    method: 'GET',
                });

                this.form = { ...resp.data.item, accno: resp.data.item.accno ? `${resp.data.item.accno}` : resp.data.item.accno };
                this.$refs.ahSuggestAccountingItemsSelector.init(this.form.iteM_SNO);
                // this.updateFormType();
                this.updateStatementByType(false);
            } finally {
                this.isLoading = false;
            }
        },

        onVaribleStateSelectorLoaded() {
            // force update value
            const sno = this.form.iteM_SNO;
            this.form.iteM_SNO = null;
            setTimeout(() => {
                this.form.iteM_SNO = sno;
            }, 2);
        },

        onBankChange(bank) {
            // 變更銀行帳戶：同時變更對應的幣別
            this.form.cny = bank.cny;
            this.form.rat = _.find(this.currencyList, ['cny', bank.cny])?.rat || 0;
        },

        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.isSubmitting = true;
                    try {
                        await this.$api({
                            url: 'VariableStatementSettingPage/UpsertStatementForm',
                            method: 'POST',
                            data: this.form,
                        });
                        this.onClose();
                        this.$emit('refresh');
                    } finally {
                        this.isSubmitting = false;
                    }
                } else {
                    this.scrollViewToError();
                }
            });
        },

        onTypeChange() {
            this.updateStatementByType();
        },

        updateFormType() {
            if (this.urlType === 'payout') this.form.type = 2;
            if (this.urlType === 'income') this.form.type = 1;
        },

        updateStatementByType(resetItemSno = true) {
            this.statementType = this.getTypeNameByNum(this.form.type);
            if (resetItemSno) this.form.iteM_SNO = null;
        },

        getTypeNameByNum() {
            // "其他收入"
            if (this.form.type === 1) return 'cIn';
            // "其他支出"
            if (this.form.type === 2) return 'cOut';
            // "財務收入"
            if (this.form.type === 5) return 'cInElse';
            // "財務支出"
            if (this.form.type === 6) return 'cOutElse';
            return null;
        },

        isRemittance(itemSno) {
            if (!itemSno) return false;
            const hierarchy = [null, null, null];

            for (const t in statementTypes) {
                const options = this.$store.getters['statement/statementUiOptions'][statementTypes[t].key];
                for (const i in options) {
                    const lv1Item = options[i];
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = statementTypes[t].value;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return _.last(hierarchy) === '匯費';
        },

        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        onOpen() {
            if (this.sno) {
                this.isAhSuggestAccountingItemsSelectorShow = true;
                this.fetchExistsData(this.sno);
            } else {
                this.isAhSuggestAccountingItemsSelectorShow = false;
                this.form.flg = this.purpose === 'payout' ? -1 : 1;
                this.updateFormType();
                this.updateStatementByType();
            }
        },

        onClose() {
            this.$emit('close', { visible: false });
            this.suggestAccountItems = [];
            this.form = {
                type: 0, // 1:營業其他收入, 2:營業其他支出, 5: 財務資產收入, 6:財務資產支出
                sno: null,
                flg: null,
                bnK_SNO: null,
                paY_DAT: Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                ),
                iteM_SNO: null,
                accno: null,
                cny: 'TWD',
                amt: null,
                rat: 1,
                tpc: null,
                mem: null,
                vdR_BNK_BOO: null,
                vdR_BNK_DOO: null,
                vdR_BNK_ACC: null,
                vdR_BNK_TPC: null,
            };
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                this.$refs.form.clearValidate();
            });
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded(show) {
            this.isAhSuggestAccountingItemsSelectorShow = show && (this.isPayed('G01') || this.$store.getters['account/isSAAdmin']);
        },

        onChangeFiles(value) {
            this.form.attachments = _.map(value, (o) => ({
                nam: o.nam,
                note: o.note,
                attachmentUrl: o.filE_ATT,
                upD_NAM: o.updateUser,
                upD_DAT: o.updateTime,
            }));
        },
        onTpcInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
.variable-edit-dialog {
    margin-top: 40px;

    .transfer-section {
        background-color: #f8f8f8;
        padding: 20px;
        border-radius: 10px;
        .section-title {
            font-weight: bold;
            padding: 0 0 5px 0;
            margin: 0px 0 20px 0;
            color: #463cb2;
            border-bottom: 1px solid #463cb2;
        }
    }

    .files-view-section{
        margin: 20px 0;
        padding: 10px;
    }
}
</style>
